//import _ from 'underscore'

import templateUrl from "emun.salesrep/inside-sales-dashboard.htm";
import salesrepConfig from "emun.salesrep/salesrep.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";

class InsideSalesDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    var map = this;
    let $ctrl = this;
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    this.productImage = $appConfig.productImage.bind($appConfig);
    this.todaySales = {
      total: 0,
      count: 0,
    };
    this.yesterdaySales = {
      total: 0,
      count: 0,
    };
    this.weekSales = {
      total: 0,
      count: 0,
    };
    this.lastweekSales = {
      total: 0,
      count: 0,
    };
    this.monthSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastmonthSales = {
      total: 0,
      count: 0,
    };
    this.quarterSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastquarterSales = {
      total: 0,
      count: 0,
    };
    this.ytdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastytdSales = {
      total: 0,
      count: 0,
    };
    this.goals = {
      month: 0,
      monthPercent: 0,
      quarter: 0,
      quarterPercent: 0,
      year: 0,
      yearPercent: 0,
    };
    this.uniqueCustomersBooked = 0;
    this.newAccountsBooked = 0;
    this.newAccountsBookedYTD = 0;
    this.storeVisits = 0;
    this.avgAppointment = 0;

    var querySalesTotalsCriteria = "";
    var queryCriteria = "";
    var queryGoalsCriteria = "";
    if ($ctrl.writingRepId) {
      queryCriteria = "&WritingRepID=" + $ctrl.writingRepId;
      queryGoalsCriteria = "&SalesRepID=" + $ctrl.writingRepId;
      querySalesTotalsCriteria = "&WritingRep=" + $ctrl.writingRepId;
    } else if ($ctrl.salesRepId) {
      queryCriteria = "&SalesRepID=" + $ctrl.salesRepId;
      queryGoalsCriteria = "&SalesRepID=" + $ctrl.salesRepId;
      querySalesTotalsCriteria = "&SalesRepID=" + $ctrl.salesRepId;
    }

    //only run this for the pure inside sales rep
    if ($ctrl.writingRepId) {
      $ctrl.writingRepNameQuery = createAutoQuery({
        url:
          "QuerySalesReps.json?IncludeSalesData=false&Id=" + $ctrl.writingRepId,
        autoLoad: true,
        pageSize: 1000,
        onLoaded: function (args) {
          if (args.total > 0) {
            $ctrl.rep = args.first;
            $ctrl.$state.current.customTitle = $ctrl.rep.name;
            $ctrl.writingRepName = $ctrl.rep.name;
          }
        },
      });
    }

    $ctrl.todaySalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=Today&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.todaySales.total += Math.round(res.sumOrderTotal);
            $ctrl.todaySales.count += res.countOrderTotal;
          });
          $ctrl.bookingsToday = $ctrl.todaySales.total;
        }
      },
    });

    $ctrl.yesterdaySalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=Yesterday&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.yesterdaySales.total += Math.round(res.sumOrderTotal);
            $ctrl.yesterdaySales.count += res.countOrderTotal;
          });
          $ctrl.bookingsYesterday = $ctrl.yesterdaySales.total;
        }
      },
    });

    $ctrl.bookingsThisWeek = 0;
    $ctrl.weekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=Week&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.weekSales.total += Math.round(res.sumOrderTotal);
            $ctrl.weekSales.count += res.countOrderTotal;
          });
          $ctrl.bookingsThisWeek = $ctrl.weekSales.total;
        }
      },
    });
    $ctrl.lastweekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.lastweekSales.total += Math.round(res.sumOrderTotal);
            $ctrl.lastweekSales.count += res.countOrderTotal;
          });
        }
      },
    });
    $ctrl.monthSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=Month&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.monthSales.total += Math.round(res.sumOrderTotal);
            $ctrl.monthSales.count += res.countOrderTotal;
          });
          $ctrl.lastmonthSalesQuery = createAutoQuery({
            url:
              "QuerySalesDailyTotals.json?dateRange=LYMTD&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
              queryCriteria,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function (args) {
              if (args.total > 0) {
                args.results.forEach(function (res) {
                  $ctrl.lastmonthSales.total += Math.round(res.sumOrderTotal);
                  $ctrl.lastmonthSales.count += res.countOrderTotal;
                });
                var percent = Math.round(
                  ($ctrl.monthSales.total / $ctrl.lastmonthSales.total) * 100
                );
                if (percent < 100) {
                  $ctrl.monthSales.percent = 100 - percent;
                  $ctrl.monthSales.trend = "down";
                } else if (percent > 100) {
                  $ctrl.monthSales.percent = percent - 100;
                  $ctrl.monthSales.trend = "up";
                } else {
                  $ctrl.monthSales.percent = 100;
                  $ctrl.monthSales.trend = "neutral";
                }
              }
            },
          });
        }
      },
    });
    $ctrl.quarterSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=Quarter&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.quarterSales.total += Math.round(res.sumOrderTotal);
            $ctrl.quarterSales.count += res.countOrderTotal;
          });
          $ctrl.lastquarterSalesQuery = createAutoQuery({
            url:
              "QuerySalesDailyTotals.json?dateRange=LYQTD&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
              queryCriteria,
            autoLoad: true,
            onLoaded: function (args) {
              if (args.total > 0) {
                args.results.forEach(function (res) {
                  $ctrl.lastquarterSales.total += Math.round(res.sumOrderTotal);
                  $ctrl.lastquarterSales.count += res.countOrderTotal;
                });
                var percent = Math.round(
                  ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) *
                    100
                );
                if (percent < 100) {
                  $ctrl.quarterSales.percent = 100 - percent;
                  $ctrl.quarterSales.trend = "down";
                } else if (percent > 100) {
                  $ctrl.quarterSales.percent = percent - 100;
                  $ctrl.quarterSales.trend = "up";
                } else {
                  $ctrl.quarterSales.percent = 100;
                  $ctrl.quarterSales.trend = "neutral";
                }
              }
            },
          });
        }
      },
    });
    $ctrl.ytdSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=YTD&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.ytdSales.total += Math.round(res.sumOrderTotal);
            $ctrl.ytdSales.count += res.countOrderTotal;
          });
          $ctrl.lastytdSalesQuery = createAutoQuery({
            url:
              "QuerySalesDailyTotals.json?dateRange=LYTD&Sum=OrderTotal&Count=OrderTotal&IsInsideSales=true&GroupBy=RepGroupName" +
              queryCriteria,
            autoLoad: true,
            onLoaded: function (args) {
              if (args.total > 0) {
                args.results.forEach(function (res) {
                  $ctrl.lastytdSales.total += Math.round(res.sumOrderTotal);
                  $ctrl.lastytdSales.count += res.countOrderTotal;
                });
                var percent = Math.round(
                  ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
                );
                if (percent < 100) {
                  $ctrl.ytdSales.percent = 100 - percent;
                  $ctrl.ytdSales.trend = "down";
                } else if (percent > 100) {
                  $ctrl.ytdSales.percent = percent - 100;
                  $ctrl.ytdSales.trend = "up";
                } else {
                  $ctrl.ytdSales.percent = 100;
                  $ctrl.ytdSales.trend = "neutral";
                }
              }
            },
          });
        }
      },
    });

    this.uniqueCustomersBooked = 0;
    this.uniqueCustomersBookedQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?dateRange=Week&CountDistinct=CustomerId&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.uniqueCustomersBooked += total.countDistinctCustomerId;
          });
        }
      },
    });

    var startWeek = moment().startOf("week").format("MM/DD/YYYY");
    this.newAccountsBookedWTDQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?dateRange=Week&SinceCreatedDate=" +
        startWeek +
        "&CountDistinct=CustomerId&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.newAccountsBooked += total.countDistinctCustomerId;
          });
        }
      },
    });

    //var startMonth = moment().startOf('month').format("MM/DD/YYYY");
    //this.newAccountsBookedMTDQuery = createAutoQuery({
    //  url: 'QuerySalesDailyCustomerTotals.json?dateRange=Month&SinceCreatedDate=' + startMonth + '&CountDistinct=CustomerId&IsInsideSales=true&GroupBy=RepGroupName' + queryCriteria,
    //  autoLoad: true,
    //  pageSize: 1000,
    //  onLoaded: args => {
    //    if (args.total > 0) {
    //      args.results.forEach(function (total) {
    //        $ctrl.newAccountsBooked += total.countDistinctCustomerId;
    //      });
    //    }
    //  }
    //});

    var startYear = moment().startOf("year").format("MM/DD/YYYY");
    this.newAccountsBookedYTDQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?dateRange=Year&SinceCreatedDate=" +
        startYear +
        "&CountDistinct=CustomerId&IsInsideSales=true&GroupBy=RepGroupName" +
        queryCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: (args) => {
        if (args.total > 0) {
          args.results.forEach(function (total) {
            $ctrl.newAccountsBookedYTD += total.countDistinctCustomerId;
          });
        }
      },
    });
    var timezone = moment.tz.guess();
    this.currentDate = moment.tz(timezone).format("MM/DD/YYYY");
    var dashboardActivityType =
      salesrepConfig.dashboardActivityType || "Phone/Email";
    dashboardActivityType = dashboardActivityType.replace(" ", "%20");

    if ($ctrl.writingRepId) {
      dashboardActivityType = "Phone/Email";
    }

    this.storeVisitsQuery = createAutoQuery({
      url:
        "QueryActivitiesJoin.json?typeIn=" +
        dashboardActivityType +
        "&dateRange=Week&Count=Id&GroupBy=username&Username=" +
        $ctrl.writingRepId,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate,
      },
      onLoaded: (args) => {
        if (args.total > 0) {
          $ctrl.storeVisits = Math.round(args.first.Total);
        }
      },
    });

    $ctrl.goalsQuery = createAutoQuery({
      url:
        "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter,RepInsideSalesGoalThisMonth,RepInsideSalesGoalThisYear,RepInsideSalesGoalLastYear,RepInsideSalesGoalLastMonth,RepInsideSalesGoalThisQuarter&IsInsideSales=true&GroupBy=vendorID" +
        queryGoalsCriteria,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          if ($ctrl.salesRepId) {
            args.results.forEach(function (res) {
              $ctrl.goals.month += Math.round(
                res.sumRepInsideSalesGoalThisMonth
              );
              $ctrl.goals.quarter += Math.round(
                res.sumRepInsideSalesGoalThisQuarter
              );
              $ctrl.goals.year += Math.round(res.sumRepInsideSalesGoalThisYear);
            });
          } else {
            args.results.forEach(function (res) {
              //$ctrl.goals.month += Math.round(res.sumRepInsideSalesGoalThisMonth);
              //$ctrl.goals.quarter += Math.round(res.sumRepInsideSalesGoalThisQuarter);
              //$ctrl.goals.year += Math.round(res.sumRepInsideSalesGoalThisYear);
              $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
              $ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
              $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
            });
          }
          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.monthSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
        }
      },
    });

    this.$session = $session;
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }

  runReport(name) {
    const $ctrl = this;
    $ctrl.currentReport = name;
    const url = $appConfig.resolveServiceUrl(
      name +
        "?WritingRepID=" +
        $ctrl.writingRepId +
        "&WritingRep=" +
        $ctrl.writingRepId
    ); //have to do this because some reports take WritingRepID and some take WritingRep, it will ignore what it doesn't need

    return (location.href = url);
  }
}

let InsideSalesDashboard = {
  bindings: {
    repGroup: "@",
    repGroupId: "@",
    header: "@",
    writingRepId: "@",
    writingRepName: "@",
    fromRepDashboard: "@",
    salesRepId: "@",
  },
  controller: InsideSalesDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default InsideSalesDashboard;
